import React from 'react'

import dayjs from 'dayjs'
import { omit } from 'lodash'
import {
  Col,
  Form,
  Row
} from 'react-bootstrap'

import { StyledSelect } from '../../common/StyledSelect'
import { getAuthorsList } from '../../services/HomePage'
import { DateRangePicker } from './DateRangePicker'
import { YearPicker } from './YearPicker'

export const SearchForm = ({ params, setParams, loadData, resetPage }: any) => {
  const onTextSearchChange = (e: any) => {
    setParams({ ...params, searchText: e.target.value })
  }

  const onEdmedSearchChange = (e: any) => {
    setParams({ ...params, edmedText: e.target.value })
  }

  const onAuthorSelect = (val: any) => {
    setParams({ ...params, authors: val.map((x: any) => x.value) })
  }

  const onPubDateChange = (start?: Date, end?: Date) => {
    if (!start && !end) {
      setParams(omit(params, 'publicationYear'))
    } else {
      const r: {start?: string, end?: string} = {}
      if (start) {
        r.start = dayjs(start).format('YYYY')
      }
      if (end) {
        r.end = dayjs(end).format('YYYY')
      }
      setParams({
        ...params,
        publicationYear: r
      })
    }
  }

  const onTempCoverageChange = (start?: Date, end?: Date) => {
    if (!start && !end) {
      setParams(omit(params, 'temporalCoverage'))
    } else {
      const r: {start?: string, end?: string} = {}
      if (start) {
        r.start = dayjs(start).format('YYYY-MM-DD')
      }
      if (end) {
        r.end = dayjs(end).format('YYYY-MM-DD')
      }
      setParams({
        ...params,
        temporalCoverage: r
      })
    }
  }

  const onKeyPress = (key: string) => {
    if (key === 'Enter') {
      onSubmit()
    }
  }

  const onSubmit = () => {
    resetPage()
    loadData()
  }

  return (
    <div className='mb-5 mt-5'>
      <Row className='mb-3'>
        <Col>
          <Form.Group id='author-search'>
            <Form.Label>Author/Contributor</Form.Label>
            <StyledSelect
              loadOptions={getAuthorsList}
              isClearable
              isMulti
              noOptionsMessage={({ inputValue }: {inputValue: string}) => (inputValue === '' ? 'Start typing to show options' : 'No options')}
              onChange={onAuthorSelect}
              id='author-select'
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group id='text-search'>
            <Form.Label>Text Search</Form.Label>
            <input type='text' value={params.searchText} onChange={onTextSearchChange} onKeyUp={e => onKeyPress(e.key)} />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <Form.Group id='publication-year-search'>
            <Form.Label>Publication Year</Form.Label>
            <YearPicker
              onChange={onPubDateChange}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group id='temporal-coverage-search'>
            <Form.Label>Temporal Coverage</Form.Label>
            <DateRangePicker
              onChange={onTempCoverageChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <Form.Group id='edmed-search'>
            <Form.Label>Data Collection (EDMED)</Form.Label>
            <input type='text' value={params.edmedText} onChange={onEdmedSearchChange} onKeyUp={e => onKeyPress(e.key)} />
          </Form.Group>
        </Col>
        <Col>
        </Col>
      </Row>

      <Row>
        <Col style={{ textAlign: 'right' }}>
          <button className='styledButton' onClick={onSubmit} id='search-btn'>
            Search
          </button>
        </Col>
      </Row>
    </div>
  )
}
